var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M10.47 4.47a.75.75 0 011.06 1.06l-5.72 5.72H20c.38 0 .7.28.74.65l.01.1c0 .41-.34.75-.75.75H5.81l5.72 5.72c.27.27.3.68.07.98l-.07.08c-.3.3-.77.3-1.06 0l-7-7a.75.75 0 010-1.06z"}})}
var staticRenderFns = []

export { render, staticRenderFns }